<template>
    <mds-layout-grid>
        <mds-row e2e="reinvestment-summary">
            <mds-col :cols="3">
                <mds-label :text="getUILabel('transactions_reinvestCapitalGains')" size="small">
                    <mds-microcopy size="small">{{ reinvestCapitalGains }}</mds-microcopy>
                </mds-label>
            </mds-col>
            <mds-col :cols="3" :pull="6">
                <mds-label :text="getUILabel('transactions_reinvestDividends')" size="small">
                    <mds-microcopy size="small">{{ reinvestDividends }}</mds-microcopy>
                </mds-label>
            </mds-col>
        </mds-row>
    </mds-layout-grid>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import MwcVueHelperMixin from "mwc-vue-component-helper";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";
import MdsLabel from "@mds/label";
import MdsMicrocopy from "@mds/microcopy";
export default {
    name: "reinvestment-summary",
    mixins: [HypoVueBaseMixin, MwcVueHelperMixin],
    components: {
        MdsLayoutGrid,
        MdsRow,
        MdsCol,
        MdsLabel,
        MdsMicrocopy
    },
    computed: {
        reinvestCapitalGains() {
            const labelId = this.$store.state.reinvestment.reinvestCapitalGains ? "transactions_yes" : "transactions_no";
            return this.getUILabel(labelId);
        },
        reinvestDividends() {
            const labelId = this.$store.state.reinvestment.reinvestDividends ? "transactions_yes" : "transactions_no";
            return this.getUILabel(labelId);
        }
    }
};
</script>
